import { Canvas, useFrame } from "@react-three/fiber";
import { useDevice, useTheme } from "../../common/hooks";
import { themeKeys } from "../../constants/themes";

import CameraControl from "./camera";
import { home } from "../../constants/points";
import TWEEN from "@tweenjs/tween.js";

function FiberConfig({ children }) {
  useFrame(() => TWEEN.update());

  return children;
}

function CanvasCustom({ children }) {
  const { themeKey } = useTheme();
  const { device } = useDevice();
  const { position, target } = home.camera[device];

  const style = {
    position: "fixed",
    top: "0",
    left: "0",
    outline: "none",
    background:
      "linear-gradient(180deg, #00000A 0%, #082B4A 30%, #0062FA 70%, #9AEEFF 100%)",
    backgroundSize: "400% 400%",
    backgroundPosition: themeKey === themeKeys.DARK ? "90% 0%" : "0% 90%",
    transition: "all 3s ease-out",
    overflow: "hidden",
  };

  return (
    <Canvas
      gl={{ preserveDrawingBuffer: true }}
      camera={{
        position: [position.x, position.y, position.z],
        target: [target.x, target.y, target.z],
        fov: device === "mobile" ? 40 : 30,
        near: 0.1,
        far: 100,
      }}
      style={style}
      shadows
    >
      <CameraControl />
      <FiberConfig>{children}</FiberConfig>
    </Canvas>
  );
}

export default CanvasCustom;
